import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconControlKeyRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconControlKeyRight"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM14 6.58579L10.5858 10L12 11.4142L14 9.41421L16 11.4142L17.4142 10L14 6.58579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconControlKeyRight;
